var activeEvents = require('../events/eventObserver'),
  configManager = require('../config/configManager'),
  CONST_EVENTS = require('../constants/events'),
  CONST_VIEWS = require('../constants/views'),
  containerName = 'ElementContainer',
  events = require('../events/eventObserver'),
  log = require('./logger').getLoggerInstance('Base.UiManager'),
  endpointMonitor = require('./endpointMonitor'),
  htmlUtility = require('../utilities/htmlUtility'),
  passiveEvents = events.passive,
  RSVP = require('rsvp'),
  viewFrameworkPlugin,
  isAlreadyLoading = false;

require('./ui/scss/genericStyles.scss');

var publicMethods = {
  getMerchantCustomContent: function (paymentType) {
    var merchantCustomContentId = configManager.getPaymentConfig(paymentType).CustomContentID;
    if (merchantCustomContentId) {
      var merchantCustomContentContainer = document.getElementById(merchantCustomContentId);
      if (merchantCustomContentContainer) {
        return merchantCustomContentContainer.innerHTML;
      }
    }
  },
  plugin: {
    load: function (viewFrameworkKey) {
      return new RSVP.Promise(function(resolve){
        if (!isAlreadyLoading && viewFrameworkPlugin === undefined) {
          log.info("Loading UI Framework [" + viewFrameworkKey + "]");
  
          isAlreadyLoading = true;
  
          switch (viewFrameworkKey.toLowerCase()) {
            case CONST_VIEWS.FRAMEWORKS.BOOTSTRAP3:
              require.ensure([], function (require) {
                viewFrameworkPlugin = require('./ui/overlay/bootstrap3/bootstrap3Plugin');
                isAlreadyLoading = false;                
                resolve();
  
                endpointMonitor.captureTiming(htmlUtility.getCurrentScript());
              }, "Overlay Plugin - Bootstrap3");
              break;
            case CONST_VIEWS.INLINE:
              require.ensure([], function (require) {
                viewFrameworkPlugin = require('./ui/inlinePlugin');
                isAlreadyLoading = false;
                resolve();
  
                endpointMonitor.captureTiming(htmlUtility.getCurrentScript());
              }, "Inline Plugin");
              break;
  
            default:
              require.ensure([], function (require) {
                viewFrameworkPlugin = require('./ui/overlay/cardinal/cardinalOverlayPlugin');
                isAlreadyLoading = false;
                resolve();
  
                endpointMonitor.captureTiming(htmlUtility.getCurrentScript());
              }, "Overlay Plugin - Cardinal");
              break;              
          }
        } else {
          resolve();
        }
      })
    },
    /**
     * Generates the base templated needed for the UI Engine and injects it into the page. 
     * @param {{paymentBrandTemplate: string, merchantCustomContent: Object, optionOverrides?: Object, paymentData: any}} renderDetails - An object that describes what to render
     * @returns PromiseLike;
     */
    render: function (renderDetails) {
      var containerDiv = document.createElement('div');
      containerDiv.id = configManager.getSystemConfig().elementPrefix + containerName;

      return viewFrameworkPlugin.plugin.render(renderDetails.paymentBrandTemplate, renderDetails.merchantCustomContent, containerDiv, renderDetails.optionOverrides, renderDetails.paymentData);
    },
    teardown: function () {
      var elementContainer = document.getElementById(configManager.getSystemConfig().elementPrefix + containerName);
      if (elementContainer) {
        elementContainer.parentNode.removeChild(elementContainer);
      }
    },
    events: {
      show: function () {
        passiveEvents.publish(CONST_EVENTS.UI_RENDER, false);
        viewFrameworkPlugin.plugin.events.show();
      },
      close: function () {
        passiveEvents.publish(CONST_EVENTS.UI_CLOSE, false);
        viewFrameworkPlugin.plugin.events.close();
      },
      stealthMode: function () {
        passiveEvents.publish(CONST_EVENTS.UI_RENDER_HIDDEN, false);
        viewFrameworkPlugin.plugin.events.stealthMode();
      }
    }
  },
  loader: {
    events: {
      show: function () {
        var div = document.createElement('div');
        div.id = configManager.getSystemConfig().elementPrefix + 'ElementLoader';
        div.innerHTML = viewFrameworkPlugin.loader.render();
        document.body.appendChild(div);

        passiveEvents.publish(CONST_EVENTS.UI_LOADING_RENDER);
        viewFrameworkPlugin.loader.events.show();
      },
      hide: function () {
        var elementLoader = document.getElementById(configManager.getSystemConfig().elementPrefix + 'ElementLoader');
        if (elementLoader) {
          viewFrameworkPlugin.loader.events.hide();

          passiveEvents.publish(CONST_EVENTS.UI_LOADING_CLOSE);
          elementLoader.parentNode.removeChild(elementLoader);
        }
      }
    }
  }
};

activeEvents.subscribe('error.fatal', function () {
  publicMethods.loader.hide();
  publicMethods.plugin.events.close();
  publicMethods.plugin.teardown();
});

module.exports = publicMethods;


//////////////////
// WEBPACK FOOTER
// ./libraries/uiManager.js
// module id = 75
// module chunks = 0 5 20